import React, { useEffect } from 'react';
import { useAppDispatch } from 'Redux/store';
import { useSelector } from 'react-redux';
import {
  selectCurrentOrder,
  selectPreviousOrders,
  selectOrderLoading,
} from 'Redux/Order/slice';
import { resetPreviousOrders } from 'Redux/Order/slice';
import { getPreviousOrders } from 'Redux/Order/reducer';
import { Alert, Spin } from 'antd';
import { getDatesRange, stringToMiles } from 'Shared/Utils';
import styles from './PreviousOrders.module.scss';

export const PreviousOrders: React.FC = () => {
  const currentOrder = useSelector(selectCurrentOrder);
  const previousOrders = useSelector(selectPreviousOrders);
  const isLoading = useSelector(selectOrderLoading);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (currentOrder) {
      dispatch(getPreviousOrders(currentOrder?.id));
    }

    return () => {
      dispatch(resetPreviousOrders());
    };
  }, [currentOrder, dispatch]);

  return (
    <>
      {currentOrder && (
        <div className={styles.previousOrders}>
          <h3 className={styles.previousOrders__title}>
            Previously on this route
          </h3>
          {isLoading ? (
            <Spin className={styles.previousOrders__spinner} />
          ) : !!previousOrders.length ? (
            <div className={styles.previousOrders__scrollbarWrapper}>
              <div className={styles.previousOrders__tableWrapper}>
                <table className={styles.previousOrders__table}>
                  {previousOrders.map((order) => {
                    return (
                      <React.Fragment key={order.id}>
                        <thead className={styles.previousOrders__thead}>
                          <tr>
                            <th className={styles.previousOrders__thead__cell}>
                              DATA
                            </th>
                            <th className={styles.previousOrders__thead__cell}>
                              ID
                            </th>
                            <th className={styles.previousOrders__thead__cell}>
                              DISTANCE - COST
                            </th>
                          </tr>
                        </thead>
                        <tbody className={styles.previousOrders__tbody}>
                          <tr>
                            <td
                              className={`${styles.previousOrders__tbody__cell} ${styles.previousOrders__tbody__dateCell}`}
                            >
                              {getDatesRange({
                                startTimestamp: order.pick_up_date,
                                endTimestamp: order.deliver_date,
                              })}
                            </td>

                            <td
                              className={`${styles.previousOrders__tbody__cell} ${styles.previousOrders__tbody__idCell}`}
                              title={String(order.id)}
                            >
                              {order.id}
                            </td>

                            <td className={styles.previousOrders__tbody__cell}>
                              <div
                                className={
                                  styles.previousOrders__tbody__cell__elem
                                }
                              >
                                {stringToMiles(order.line)}&nbsp;mi
                              </div>
                              &nbsp;-&nbsp;
                              <div
                                className={
                                  styles.previousOrders__tbody__cell__elem
                                }
                              >
                                ${order?.letter?.broker_price || 0}
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </React.Fragment>
                    );
                  })}
                </table>
              </div>
            </div>
          ) : (
            <Alert message="No data available" type="info" showIcon />
          )}
        </div>
      )}
    </>
  );
};
